import VideoLightbox from '../../../js/src/__page/VideoLightbox';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		VideoLightbox.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown( e ) {
		VideoLightbox.keyDown( e );
	},
	mouseUp() {},
};
export default controller;
